module.exports = __webpack_public_path__ + "static/media/IGeneral.dd0fe79d.svg";